// :placeholder="`e.g. Sword of the warrioriii ${textTitleize(itemType)}`"
import pluralize from 'pluralize'
import _ from 'lodash'
export const textMixin = {
  methods: {
    textPluralize (text) {
      return pluralize(text)
    },
    textTitleize (text) {
      return _.startCase(_.toLower(text))
    }
  }
}
